import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_graph",
  "use": "icon-home_graph-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-home_graph\">\n<path d=\"M3 3V19C3 20.0931 3.90694 21 5 21H21V19H5V3H3ZM19.3203 6.31445L14.9883 10.6055L11.9941 7.74219L6.30273 13.2832L7.69727 14.7168L12.0059 10.5215L15.0117 13.3945L20.7285 7.73438L19.3203 6.31445Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol